import { gql } from '@apollo/client';

const UPDATE_ACCOUNT_STATUS = gql`
  mutation UpdateStatusOnAccounts(
    $accountIds: [String!]!
    $agentName: String! = "anonymous"
    $customerId: String!
    $operation: AccountUpdateStatusOp!
    $reasonCode: AccountStatusReasonCodeV2!
    $statusCode: AccountStatusCode!
  ) {
    updateStatusOnAccounts(
      customerId: $customerId
      updateStatusOnAccountsInput: {
        accountIds: $accountIds
        agentName: $agentName
        operation: $operation
        reasonCode: $reasonCode
        statusCode: $statusCode
      }
    ) {
      identifiers
    }
  }
`;

export { UPDATE_ACCOUNT_STATUS };
